import { gql } from "apollo-angular";

export const APPROVE_NOTIFICATION = gql`
  mutation approveNotification(
    $notificationId: Int!
  ) {
    approveNotification(
        notificationId: $notificationId
    ) {
      id
    }
  }
`;

export const REJECT_NOTIFICATION = gql`
  mutation rejectNotification(
    $notificationId: Int!
  ) {
    rejectNotification(
        notificationId: $notificationId
    ) {
      id
    }
  }
`;